import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Typography } from '@knockrentals/knock-shared-web-v2';
import { Box } from '@material-ui/core';

export const PageHeader = ({ children, description, title }) => {
  return (
    <Flex justifyContent="space-between">
      <Box flex={1}>
        <Typography gutterBottom variant="h5">
          {title}
        </Typography>

        <Typography color="textSecondary" variant="body2">
          {description}
        </Typography>
      </Box>
      <div>{children}</div>
    </Flex>
  );
};

PageHeader.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  title: PropTypes.string,
};
